import { render, staticRenderFns } from "./Microregion.container.vue?vue&type=template&id=5cc24ed2&"
import script from "./Microregion.container.vue?vue&type=script&lang=ts&"
export * from "./Microregion.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports